import React from "react";
  import { Bubble } from 'react-chartjs-2';
  import "chartjs-plugin-datalabels";
  import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from "chart.js";
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import 'chart.js/auto';


  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels // Register the DataLabels plugin
  );
  

  const HomepageBublesGraphs = (props) => {
    var mainSpeciesGroups = [ "Pinus", "Salix","Acer", "Abies", "Juniperus", "Eucalyptus", "Prunus", "Populus", "Terminalia", "Quercus",];
    //["Betula", "Quercus",   "Ficus",  "Pinus","Juniperus",  "Eucalyptus",  "Salix" ];
    var xAxis = [0,1.1,0,4.5,2.5,2.7,6,5,4,6];
    var yAxis = [2,7,8,4,8,3,2.5,1,7,8];
       //     ]
       //"Sorbus","Abies",,
    // Chart data
    const data = {
        datasets: [
            {
              label: '',
              labels: mainSpeciesGroups.map(spec => props.data.filter(elem => elem.name.includes(spec)).length),
              data: mainSpeciesGroups.map((spec, index) => ({
                x: xAxis[index],
                y: yAxis[index],
                r: props.data.filter(elem => elem.name.includes(spec)).length/1.5
            })),
              backgroundColor: 'rgba(74, 122, 86, 0.5)',
            }
          ],
    };
  
    // Chart options
    const options = {
      responsive: true,
      plugins: {
        legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function(context) {

                let label = context.dataset.label || '';

                if (label) {
                    label += ': ';
                }
                if (context.dataset[context.dataIndex] !== null) {
                
                    label += context.dataset.labels[context.dataIndex].toString() + " species";
                    //context.dataset[context.dataIndex].toString();
                }
                return label;
            }
      
             // label: (yDatapoint) => {return yDatapoint.r.toString()},
                // label: function(context) {
                //   console.log(context);
                //     let label = mainSpeciesGroups[context.dataIndex] + context.dataIndex.labels.toString() ;
                //     return label;
                // }
            }
        },
      
          datalabels: {
            
           align: props.lang === "ar" ? "right" : "center",
           offset: props.lang === "ar" ? 30 : 0,
           anchor: props.lang === "ar" ? "center" : "",
            color: "black", 
            font: {
              size: 14,
              weight: "500",
            },
           // Label color
          //   anchor: "end", // Position the label near the bar's edge
          //   align: "top", // Align the label to the top of the bar
            formatter: (value, context) =>  mainSpeciesGroups[context.dataIndex] + ": " + value.r*1.5, // Format the label (e.g., show the value)
          },
        },
      scales: {
        // to remove the labels
        x: {
            display: false,
          ticks: {
            display: false,
          },
          // to remove the x-axis grid
          grid: {
            drawBorder: false,
            display: false,
          },
        },
        // to remove the y-axis labels
        y: {
            display: false,
          ticks: {
            display: false,
            beginAtZero: true,
          },
          // to remove the y-axis grid
          grid: {
            drawBorder: false,
            display: false,
          },
        },
      },
  };

    return (
      <div style={{ width: "600px", margin: "0 auto" }}>
        <div></div>
        <Bubble data={data} 
        options={options}
         />
      </div>
    );
  };
  
  export default HomepageBublesGraphs;
  
// function HomepageBublesGraphs(props) {
//            console.log(props.data.sort((a, b) => {
//             const nameA = a.name.toUpperCase(); // ignore upper and lowercase
//             const nameB = b.name.toUpperCase(); // ignore upper and lowercase
//             if (nameA < nameB) {
//               return -1;
//             }
//             if (nameA > nameB) {
//               return 1;
//             }
          
//             return 0;
//           }));         
//   return (
//     <section > <div className="chartContainer">
        
//       <Bubble options={options} data={data}  plugins={[ChartDataLabels]}/>
//       </div>
//  {/* <div>{props.data.sort((a, b) => {
//             const nameA = a.name.toUpperCase(); // ignore upper and lowercase
//             const nameB = b.name.toUpperCase(); // ignore upper and lowercase
//             if (nameA < nameB) {
//               return -1;
//             }
//             if (nameA > nameB) {
//               return 1;
//             }
          
//             return 0;
//           }).map(elem => elem.name).toString()}</div> */}
//     </section>
//   )
// }
// export default HomepageBublesGraphs